module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.save.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Member ids(such as xxx,xxx,xxx)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.msg.condition.member_ids),
      expression: "msg.condition.member_ids"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "xxx",
      "required": "required"
    },
    domProps: {
      "value": (_vm.msg.condition.member_ids)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.msg.condition, "member_ids", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Title (Optional)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.msg.title),
      expression: "msg.title"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.msg.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.msg, "title", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Message Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.msg.category),
      expression: "msg.category"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.msg, "category", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.categories), function(item, index) {
    return _c('option', {
      key: index
    }, [_vm._v("\n                " + _vm._s(item) + "\n              ")])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Text")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.msg.text),
      expression: "msg.text"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "10em"
    },
    attrs: {
      "required": "required",
      "name": "content_en"
    },
    domProps: {
      "value": (_vm.msg.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.msg, "text", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Enter App Path ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.msg.link),
      expression: "msg.link"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "link",
      "required": "required"
    },
    domProps: {
      "value": (_vm.msg.link)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.msg, "link", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Delivery Method")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.msg.channel),
      expression: "msg.channel"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.msg, "channel", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "inner_msg"
    }
  }, [_vm._v("Push and In-app message")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "app"
    }
  }, [_vm._v("Push only")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("When to send this Notification?")]), _vm._v(" "), _c('br', {
    staticClass: "clear"
  }), _vm._v(" "), _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.msg_type),
      expression: "msg_type"
    }],
    attrs: {
      "type": "radio",
      "name": "when",
      "value": "now"
    },
    domProps: {
      "checked": _vm._q(_vm.msg_type, "now")
    },
    on: {
      "change": function($event) {
        _vm.msg_type = "now"
      }
    }
  }), _vm._v("\n              Immediately\n            ")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.msg_type),
      expression: "msg_type"
    }],
    attrs: {
      "type": "radio",
      "name": "when",
      "value": "later"
    },
    domProps: {
      "checked": _vm._q(_vm.msg_type, "later")
    },
    on: {
      "change": function($event) {
        _vm.msg_type = "later"
      }
    }
  }), _vm._v("\n              Scheduled Date\n            ")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.msg.scheduled_at != null),
      expression: "msg.scheduled_at != null"
    }],
    attrs: {
      "c": "",
      "lass": "row"
    }
  }, [_c('div', {
    attrs: {
      "c": "",
      "la": "",
      "ss": "col-xs-12 datet ime"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("D ate Time")]), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.msg.scheduled_at),
      expression: "msg.scheduled_at"
    }],
    staticClass: "form-contl datepicker",
    attrs: {
      "type": "datetime-local",
      "name": "bdaytime",
      "required": _vm.msg.scheduled_at != null
    },
    domProps: {
      "value": (_vm.msg.scheduled_at)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.msg, "scheduled_at", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('h4', [_vm._v("Preview")]), _vm._v(" "), _c('p', [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("To")]), _vm._v(" " + _vm._s(_vm.msg.condition.member_ids))]), _vm._v(" "), _c('p', [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Title")]), _vm._v(" " + _vm._s(_vm.msg.title))]), _vm._v(" "), _c('p', [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Text")]), _vm._v(" " + _vm._s(_vm.msg.text))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.msg.link),
      expression: "msg.link"
    }]
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Link")]), _vm._v(" " + _vm._s(_vm.msg.link))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.msg.scheduled_at),
      expression: "msg.scheduled_at"
    }]
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("schedule")]), _vm._v(" " + _vm._s(_vm.msg.scheduled_at) + "\n    ")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row submit"
  }, [_c('div', {
    staticClass: "cols-12"
  }, [_c('button', {
    staticClass: "btn btn-lg btn-success pns-submit"
  }, [_vm._v("\n            Send Notification\n          ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7649721b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/member_msg_form.vue
// module id = 38
// module chunks = 1